import { render } from "./levels-description.vue?vue&type=template&id=6e8343a8&scoped=true&ts=true"
import script from "./levels-description.vue?vue&type=script&lang=ts"
export * from "./levels-description.vue?vue&type=script&lang=ts"

import "./levels-description.vue?vue&type=style&index=0&id=6e8343a8&lang=scss&scoped=true"
import "./levels-description.vue?vue&type=style&index=1&id=6e8343a8&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8343a8"]])

export default __exports__